import cn from 'classnames'
import { Button } from 'react-bootstrap'
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa'
import s from './ButtonArrow.module.scss'

type Direction = 'left' | 'right'

type Position = 'before' | 'after'

interface Label {
  text: string
  position: Position
}

interface Props {
  direction?: Direction
  className?: string
  onClick?: () => void
  disabled?: boolean
  label?: Label
  size?: 'xs' | 'md'
}

const defaultProps = {
  direction: 'left',
  className: undefined,
  onClick: () => null,
  disabled: false,
  label: undefined,
  size: 'md',
}

const Icon = {
  left: <FaChevronLeft />,
  right: <FaChevronRight />,
}

const ButtonArrow = ({
  direction = defaultProps.direction as Direction,
  className,
  onClick,
  disabled,
  label,
  size = 'md',
}: Props): JSX.Element => (
  <Button
    data-testid="button-arrow"
    size="sm"
    disabled={disabled}
    variant="primary"
    className={cn(s.buttonArrow, className, s[size])}
    type="button"
    onClick={onClick}
  >
    {label && label.position === 'before' && `${label.text} `}
    {Icon[direction]}
    {label && label.position === 'after' && ` ${label.text}`}
  </Button>
)

ButtonArrow.defaultProps = defaultProps
export default ButtonArrow
